import React from 'react';
import {_GPY,__GPYPost , __GPYGet} from '../../env.js'
import GpyFileUpload from '../gametypes/lib/GpyFileUpload.js'
import SelectCountry from '../../login/SelectCountry.js'
import I18nString from '../../I18nString';

class UserAccount extends React.Component {
  constructor(props) {
   super(props);
   this.state = {
     currentUser: {id:-1},
     isCurrentUserLoaded: false,
     pleaseStore:false,
   };
  }

  onChangeField(field,validator,e) {
    var o = this.state.currentUser;
    o[field] = e.target.value;
    o["_"+field] = validator(o[field]);
    this.setState({currentUser:o,pleaseStore:true});
  }

  componentDidMount(){
      this.getUser();
  }

  getUser(){
    __GPYGet('getUser',(res)=>{
      res.User._city=true;
      res.User._firstName=true;
      res.User._lastName=true;
      res.User._street=true;
      res.User._streetNr=true;
  //    res.User._email=true;
      res.User._zipcode=true;
      if(res.User.locale === undefined) {

        var locale = (navigator.language || navigator.userLanguage || "de-DE").split("-");
        console.log("BrowserLocale:",locale);
        if(locale.length === 2){
          res.User.locale = locale[1];
        } else if(locale.length === 1){
          res.User.locale = locale[0];
        }
        if(res.User.locale === undefined) {
          res.User.locale = "DE";
        } else {
          res.User.locale = res.User.locale.toUpperCase();
        }
        console.log("UserLocale:",res.User.locale);

      }
        this.setState({currentUser:res.User,isCurrentUserLoaded:true})
    },(res)=>{
      this.setState({isCurrentUserLoaded:false})
    });
  }

  updateUser() {
    __GPYPost('updateUser',this.state.currentUser,(res)=>{
        this.setState({pleaseStore:false});
        this.getUser();
    },(err)=>{

    });
  }

  onFileUpload(file) {
    var obj = this.state.currentUser;
    obj.profileImage = file;
    console.log(obj);
    this.setState({ currentUser:obj , pleaseStore: true});
  }


  doChangeCountry(e){
      console.log("locale->",e);
      var o = this.state.currentUser;
      o.locale = e;
      this.setState({currentUser:o , pleaseStore:true});
  }


	render() {
    if(!this.state.isCurrentUserLoaded) {
      return <div/>;
    }

    var ckb = (ckb) => {
      console.log("ckb",ckb,this.state.currentUser[ckb],this.state.currentUser["_"+ckb]);
       if(this.state.currentUser[ckb] === undefined || this.state.currentUser[ckb]==='') {
         return true;
       }
       return !this.state.currentUser["_"+ckb];
    };
    const usr = this.state.currentUser;
    return (
      <div>
        <div className="row">

          <div className="col-12 pt-2">
              <div className="card bg-light">
                      <div className="card-header">User Account<I18nString prefix="UserAccount_"/>
                      </div>

                      <div className="row p-3">

                          <div className="col-3 mb-1">
                                <div className="row"><div className="col">
                                  <img style={{maxWidth : '250px', maxHeight : '500px'}} src={usr.profileImage!==undefined?_GPY.resource("upload/"+usr.profileImage):_GPY.resource("images/default_avatar.jpg")} className="img-fluid" alt="Player Avatar"/>
                                </div></div>
                                <div className="row"><div className="col">
                                  <GpyFileUpload aspectRatio="1" fileTypes="jpg,png" className="btn btn-secondary mr-2"  callBack={this.onFileUpload.bind(this)} />
                                </div></div>
                          </div>

                          {/*
                          private String firstName = null;
                            private String lastName = null;
                            private String locale = null;
                            private String email = null;
                            private String password = null;

                            private String company = null;
                            private String street = null;
                            private String streetNr = null;
                            private String zipcode = null;
                            private String city = null;
                            private String provinz = null;
                            private String umstid = null;
                            private String status = null;
                            private long lvl = 0;
                            */}

                          <div className="col-9 mb-1">

                          <div className="row">
                            <div className="col">
                              <span>{_GPY.i18n.get('UserAccount_form_input_email_title')}: <strong className="font-monospace">{usr.email}</strong></span>
                            </div>
                          </div>

                            <div className="row">
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_firstName_title')}</label>
                                <input type="text" value={usr.firstName} onChange={this.onChangeField.bind(this,"firstName",_GPY.emptyIsValid)} className={ckb("firstName")?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('UserAccount_form_input_firstName_placeholder')}/>
                                {ckb("firstName")?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
                              </div>
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_lastName_title')}</label>
                                <input type="text" value={usr.lastName}  onChange={this.onChangeField.bind(this,"lastName",_GPY.isMin2)} className={ckb("lastName")?"form-control border border-danger":"form-control"}  placeholder={_GPY.i18n.get('UserAccount_form_input_lastName_placeholder')}/>
                                {ckb("lastName")?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_company_title')}</label>
                                <input type="text" value={usr.company}  onChange={this.onChangeField.bind(this,"company",_GPY.emptyIsValid)} className="form-control" placeholder={_GPY.i18n.get('UserAccount_form_input_company_placeholder')}/>
                              </div>
                            </div>


                            <div className="row">
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_street_title')}</label>
                                <input type="text" value={usr.street} onChange={this.onChangeField.bind(this,"street",_GPY.isMin2)} className={ckb("street")?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('UserAccount_form_input_street_placeholder')}/>
                                {ckb("street")?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
                              </div>
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_streetNr_title')}</label>
                                <input type="text" value={usr.streetNr} onChange={this.onChangeField.bind(this,"streetNr",_GPY.isMin1)} className={ckb("streetNr")?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('UserAccount_form_input_streetNr_placeholder')}/>
                                {ckb("streetNr")?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_1_chars')}</small>:""}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_zipcode_title')}</label>
                                <input type="text" value={usr.zipcode} onChange={this.onChangeField.bind(this,"zipcode",_GPY.isMin2)}  className={ckb("zipcode")?"form-control border border-danger":"form-control"}  placeholder={_GPY.i18n.get('UserAccount_form_input_zipcode_placeholder')}/>
                                 {ckb("zipcode")?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
                              </div>
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_city_title')}</label>
                                <input type="text" value={usr.city} onChange={this.onChangeField.bind(this,"city",_GPY.isMin2)}  className={ckb("city")?"form-control border border-danger":"form-control"}  placeholder={_GPY.i18n.get('UserAccount_form_input_city_placeholder')}/>
                                 {ckb("city")?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <label>{_GPY.i18n.get('UserAccount_form_input_provinz_title')}</label>
                                <input type="text" value={usr.provinz} onChange={this.onChangeField.bind(this,"provinz",_GPY.emptyIsValid)} className="form-control" placeholder={_GPY.i18n.get('UserAccount_form_input_provinz_placeholder')}/>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <div className="form-group">
                                    <label>{_GPY.i18n.get('UserAccount_form_input_country_title')}</label>
                                    <SelectCountry defaultLocale={usr.locale} doChange={this.doChangeCountry.bind(this)}/>
                                </div>
                              </div>
                            </div>
{/*
                            <div className="row">
                              <div className="col">
                                 <label>Umstid</label>
                                 <input type="text" value={usr.umstid} onChange={this.onChangeField.bind(this,"umstid",_GPY.emptyIsValid)} className="form-control" placeholder="First name"/>
                              </div>
                            </div>
*/}
                          </div>

                     </div>


                      <div className="row pl-3 pr-3">
                          <div className="col-12 border-bottom"></div>
                      </div>

                      <div className="row justify-content-end p-3">
                          <div className="col-3 col-md-2 col-lg-2 text-right">
                          {this.state.pleaseStore&&usr._city&&usr._firstName&&usr._lastName&&usr._street&&usr._streetNr?
                            <button className="btn btn-success" onClick={this.updateUser.bind(this)}><span className="glyphicon glyphicon-ok"/></button>
                          :
                            <button className="btn btn-primary disabled"><span className="glyphicon glyphicon-plus"/></button>
                          }
                          </div>
                      </div>

                  </div>
            </div>
          </div>

      </div>

		 	);
    }
}
export default UserAccount;
